module.exports = __webpack_public_path__ + "img/play.0df5fb44.svg";